// Constantes de l'application
export const ROUTES = {
  HOME: '/',
  PRESENTATION: '/presentation',
  SEANCE: '/seance',
  QUI: '/qui',
  TARIFS: '/tarifs',
  CONTACT: '/contact'
};

export const EXTERNAL_LINKS = {
  RESALIB: 'https://www.resalib.fr/praticien/66295-christophe-baccou-hypnotherapeute-hendaye#newrdvmodal'
};

export const SITE_INFO = {
  title: 'Cabinet Hypnose Hendaye - Christophe BACCOU',
  description: 'Cabinet d\'hypnose à Hendaye avec Christophe Baccou, praticien certifié en hypnose ericksonienne.',
  phone: '06 37 66 52 97',
  email: 'christophebaccou.hypnose@gmail.com',
  address: '14 boulevard du Général de Gaulle 64700 HENDAYE',
  siret: '822624086'
};